import { DcFile } from "./dc-file.model";

export class TemplateFile {
    public file: DcFile;
    public templateFileId: number;
    public templateId: number;
    public type: string;

    public static build(): TemplateFile {
        const templateFile: TemplateFile = new TemplateFile();
        templateFile.file = null;
        templateFile.templateFileId = null;
        templateFile.templateId = null;
        templateFile.type = null;
        return templateFile;
    }
}